module.exports = __webpack_public_path__ + "img/vip-bg.39a6ace4.png";